import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import ProductNav from '../../common/ProductNavUs';
import { useState } from 'react';
import Bundles from '@elem/compPage/delta-3-max-series/pages/product/us/Bundles';
import CompatibilityTable from './components/CompatibilityTable';
import { getCompatibilityData } from './config';

const Compatiblity: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('Compatiblity');

    const [activeTab, setActiveTab] = useState('Compatibility');

    const { compatibilityData, tableRows, mobileTableData, alsoLike } = getCompatibilityData();

    return (
        <section className={'d3m-specs'}>
            <ProductNav activeTab={activeTab} tabCallback={setActiveTab} />

            {activeTab === 'Bundles' && (
                <>
                    <Bundles />
                </>
            )}

            {activeTab === 'Compatibility' && (
                <>
                    <CompatibilityTable data={compatibilityData} rows={tableRows} mobileTableData={mobileTableData} alsoLike={alsoLike} />
                </>
            )}
        </section>
    );
};

export default Compatiblity;
